/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

"use strict";

var Model = require("../types/Model.js");

var BANNER_MATCHES = [
	/^urgency/,
	/^warning:device:(?:battery|batterychanged)/,
	/^warning:device:(?:connected|disconnected|wandering)/
];

module.exports = Model({
	name: "banner",
	_banners: null,

	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,

	handle_unread_updated: handle_unread_updated,
	add_banner: add_banner,
	clear: clear,
	acknowledge: acknowledge,
});

/**
 * Initializes with:
 * 	- refresh list of banners
 *  - put listerner for mqtt msg reflecting a new banner
 *  - put listerner for changes to updates in persons tracked in People Model
 *  - create an array to hold raw list of banners (just _id's)
 *  - finally, update the state of the model.
 * @return {Object} Push
 */
function init() {
	this._banners = [];

	// Push an empty array as the initial state
	this.push([]);
}

function uninit() {
	this._banners = null;
}

function listeners() {
	return {
		"unreadnotifications:updated": handle_unread_updated
	};
}

function triggers() {
	return {
		"clear": clear,
		"navigate": navigate,
		"navigate:person": navigatePerson,
		"acknowledge": acknowledge,
		"wanderInvalid": wanderInvalid,
		"fallInvalid": fallInvalid,
	};
}


function navigatePerson(data) {
	this.clear(data);
	this.emit("contactprofile:trigger:profile:open", data);
}

function navigate(data) {
	this.clear(data);
	var page = data.page;
	this.dispatch("navigating", {
		page: page
	});
}

function fallInvalid(data) {
	var from = data.from;
	var falsealarm = data.falsealarm;
	this.api.device.fall.invalid({
		from: from,
		falsealarm: falsealarm
	});
}

function wanderInvalid(data) {
	var from = data.from;
	var falsealarm = data.falsealarm;
	this.api.device.wander.invalid({
		from: from,
		falsealarm: falsealarm
	});
}

function acknowledge(data) {
	var from = data.from;
	// TODO: Catch errors
	this.api.device.wander.acknowledge(from);
}

/**
 * Clear banner messages coming from a certain user
 * @param  {Object} data Must contain the key `from`, the user to clear banners from
 */
function clear(data) {
	var from = data.from;
	var type = data.type;
	var group = data.group;
	this.emit("usermetrics:trigger:track", "begin clearing banner", {
		from,
		type
	});
	return this.api.banner.read(from, type, group);
}


function getMatcher(type) {
	if (!type) {
		console.log("in Banners: Not a valid banner type.");
		return;
	}
	return BANNER_MATCHES.reduce(function(result, match) {
		if (result) return result;
		if (type.match(match)) return match;
		return null;
	}, null) || type;
}

/**
 * Refreshes the banner list and processes all the banners
 */
function handle_unread_updated(unread) {
	var banners = unread.filter(function(item) {
		var isBannerNotification = item.type.indexOf("banner") !== -1;
		return isBannerNotification;
	}.bind(this));

	var mergedBanners = banners.reduceRight(add_banner, []);
	this.push(mergedBanners);
}

/**
 * Merges in new banners. If a banner for this person exists, it is updated.
 * If the banner is from a new person, or is a new type. It is appended.
 * @param  {Object} banner Banner containing `type`, `_id`, and optional `from` and `to`
 */
function add_banner(banners, banner) {
	var matcher = getMatcher(banner.banner_type);
	var has_updated = false;

	banners = banners.map(function(item) {
		if (item.from._id !== banner.from._id) return item;
		if (!item.banner_type.match(matcher)) return item;
		has_updated = true;
		return banner;
	});

	if (!has_updated)
		banners = banners.concat(banner);

	return banners;
}
